"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HelpPopupLink = void 0;
/*
 * Copyright 2023, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const react_1 = __importDefault(require("react"));
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const faQuestionCircle_1 = require("@fortawesome/free-solid-svg-icons/faQuestionCircle");
const SimpleModal_1 = __importDefault(require("../../modal/SimpleModal"));
const HelpPopupLink = (props) => {
    const [modalIsOpened, setModalIsOpened] = react_1.default.useState(false);
    return (react_1.default.createElement("div", null,
        modalIsOpened && (react_1.default.createElement(SimpleModal_1.default, { isOpen: true, closeModal: () => setModalIsOpened(false), text: props.content(), title: props.title, containsHtml: props.containsHtml })),
        react_1.default.createElement("button", { type: "button", className: "button helper-popup blue small", onClick: () => setModalIsOpened(true) },
            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: faQuestionCircle_1.faQuestionCircle, className: "faIconLeft" }),
            props.title)));
};
exports.HelpPopupLink = HelpPopupLink;
exports.default = exports.HelpPopupLink;
//# sourceMappingURL=HelpPopupLink.js.map